import "./styles.css";
import loadAuthPage from "./pages/AuthPage";


loadAuthPage();
